export default __webpack_public_path__ + "static/anika-90c8d6feb91e3dd3492203f78ec2fb7f.jpeg";